import { bugNotif } from "../../api/bugsnag";
import { getUserHashedDetails } from "../../api/user";
import { getErrorMsg } from "../../../Common/utils/common";

declare const snaptr: (
  action: string,
  event: string,
  data?: Record<string, unknown>
) => void;

export const sendSnapTracking = async (
  userId: string,
  type: "Membership" | "One Off" | "Power Up",
  pid: string,
  value: number
) => {
  try {
    const {
      data: {
        result: { emailAddress },
      },
    } = await getUserHashedDetails(userId);

    snaptr("init", "5168c91f-aba8-405a-a9a9-f9f797c9fc2c", {
      user_email: emailAddress,
    });

    snaptr("track", "PURCHASE", {
      price: value,
      currency: "AUD",
      item_category: type,
      item_ids: [pid],
      transaction_id: `${userId}-${pid}-${new Date().valueOf()}`,
      client_dedup_id: Math.random().toString(36).substring(2, 17),
    });
  } catch (error) {
    console.log("error sendSnapTracking", error);
    bugNotif("sendSnapTracking", getErrorMsg(error).rawErrorMsg);
  }
};

export const sendSnapAddToCart = async (
  emailAddress: string,
  type: "Membership" | "One Off" | "Power Up",
  pid: string,
  value: number
) => {
  try {
    snaptr("init", "5168c91f-aba8-405a-a9a9-f9f797c9fc2c", {
      user_email: emailAddress,
    });

    snaptr("track", "ADD_CART", {
      price: value,
      currency: "AUD",
      item_category: type,
      item_ids: [pid],
      client_dedup_id: Math.random().toString(36).substring(2, 17),
    });
  } catch (error) {
    console.log("error sendSnapAddToCart", error);
    bugNotif("sendSnapAddToCart", getErrorMsg(error).rawErrorMsg);
  }
};

